import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

/* eslint-disable max-len -- SVG path `d` attributes */
const PATH_GEAR_UPPER =
  'M18.631 11.22c0-.346-.03-.69-.073-1.026l1.848-1.445c.41-.321.521-.894.261-1.345l-1.643-2.842c-.26-.45-.81-.639-1.293-.447l-1.65.663a1.07 1.07 0 0 1-.99-.118 7.948 7.948 0 0 0-.793-.461 1.069 1.069 0 0 1-.597-.794l-.25-1.76A1.043 1.043 0 0 0 12.416.75H9.14c-.518 0-.96.382-1.033.896l-.254 1.761c-.05.347-.278.634-.591.793a8.24 8.24 0 0 0-.796.466 1.069 1.069 0 0 1-.986.114l-1.653-.665a1.043 1.043 0 0 0-1.293.447L.891 7.404a1.044 1.044 0 0 0 .26 1.345l1.847 1.445c-.041.335-.073.68-.073 1.026 0 .345.03.691.073 1.026l-1.847 1.445a1.046 1.046 0 0 0-.261 1.345l1.643 2.842c.26.45.81.64 1.293.447l1.654-.664a1.06 1.06 0 0 1 .985.116c.256.17.52.325.795.466.315.159.542.445.593.793l.252 1.76c.074.513.515.895 1.034.895h1.64'

const PATH_GEAR_LOWER =
  'M2.924 11.22c0-.346.03-.69.072-1.026L1.148 8.75a1.046 1.046 0 0 1-.26-1.345L2.53 4.562c.26-.45.81-.639 1.293-.447l1.65.663c.328.132.694.076.99-.118.256-.169.52-.323.793-.461.315-.158.546-.446.596-.794l.251-1.76A1.043 1.043 0 0 1 9.138.75h3.277c.518 0 .96.382 1.033.896l.254 1.761c.049.347.278.634.591.793.275.14.54.297.796.466.294.193.659.245.985.114l1.653-.665a1.043 1.043 0 0 1 1.294.447l1.643 2.842c.261.451.149 1.025-.26 1.345l-1.848 1.445c.042.335.074.68.074 1.026 0 .345-.03.691-.074 1.026l1.848 1.445c.409.322.521.895.261 1.345l-1.643 2.842c-.26.45-.81.64-1.293.447l-1.655-.664a1.06 1.06 0 0 0-.984.116c-.256.17-.521.325-.796.466a1.067 1.067 0 0 0-.592.793l-.253 1.76a1.045 1.045 0 0 1-1.033.895h-1.64'
/* eslint-enable max-len */

function Settings2({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = 1.5,
  ...props
}) {
  return (
    <IconBase viewBox='0 0 22 23' {...props}>
      <Path
        d={PATH_GEAR_UPPER}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M12.995 8.998a3.14 3.14 0 1 1-4.44 4.442 3.14 3.14 0 0 1 4.44-4.442'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d={PATH_GEAR_LOWER}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Settings2.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  fill: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Settings2
